import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { B64Breadcrumb } from "../components/B64Breadcrumb";
import { B64Explainer } from "../components/B64Explainer";
import { Base64Tool } from "../components/Base64Tool";

export function Base64Page() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <B64Breadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.b64_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.b64_intro()}
          </p>
        </header>

        <Base64Tool />

        <B64Explainer
          howTo={m.b64_howto()}
          faqs={[
            { q: m.b64_faq1_q(), a: m.b64_faq1_a() },
            { q: m.b64_faq2_q(), a: m.b64_faq2_a() },
            { q: m.b64_faq3_q(), a: m.b64_faq3_a() },
            { q: m.b64_faq4_q(), a: m.b64_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
